import axios from "../../../axios/index.js";
import store from "../../../../store/store.js";
import router from "@/router.js";

function hasRefreshToken() {
  return Boolean(localStorage.getItem("refreshToken"));
}

function isAccessTokenExpired(exp) {
  const accessTokenExpDate = exp;
  const nowTime = Math.floor(new Date().getTime() / 1000);

  return accessTokenExpDate <= nowTime;
}

function _parseTokenData(accessToken) {
  let payload = "";
  let tokenData = {};

  try {
    payload = accessToken.split(".")[1];
    tokenData = JSON.parse(atob(payload));
  } catch (error) {
    throw console.log(error);
  }

  return tokenData;
}

function _setAuthData({ accessToken, refreshToken, exp } = {}) {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("exp", exp);
}

function _resetAuthData() {
  store.dispatch("auth/logout");
}

export default {
  init() {
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      async function(error) {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;

          try {
            const res = await axios.post("/auth/users/refresh/", {
              refresh: localStorage.getItem("refreshToken")
            });

            _setAuthData({
              accessToken: res.data.access,
              refreshToken: res.data.refresh,
              exp: _parseTokenData(res.data.access).exp
            });

            error.config.headers.Authorization = `Bearer ${localStorage.getItem(
              "accessToken"
            )}`;
          } catch (error) {
            console.log(error);
          }
          return axios(originalRequest);
        }
        return Promise.reject(error);
      }
    );

    axios.interceptors.request.use(async function(config) {
      let accessToken = localStorage.getItem("accessToken"),
        refreshToken = localStorage.getItem("refreshToken"),
        exp = localStorage.getItem("exp");

      //Если есть токен, дата окончания токена и если токен не закончился
      if (accessToken && exp && !isAccessTokenExpired(exp)) {
        //Отправляем запрос с токеном
        config.headers.Authorization = `Bearer ${accessToken}`;
      } else if (
        accessToken &&
        exp &&
        isAccessTokenExpired(exp) &&
        refreshToken &&
        config.url !== "/auth/users/refresh/"
      ) {
        await axios
          .post("/auth/users/refresh/", {
            refresh: refreshToken
          })
          .then(response => {
            _setAuthData({
              accessToken: response.data.access,
              refreshToken: response.data.refresh,
              exp: _parseTokenData(response.data.access).exp
            });

            config.headers.Authorization = `Bearer ${localStorage.getItem(
              "accessToken"
            )}`;
          })
          .catch(error => {
            _resetAuthData();
          });
      }
      return config;
    });
  },
  login(phone, pwd) {
    return axios.post("/auth/users/login/admin/", {
      phone: phone,
      password: pwd
    });
  },
  _parseTokenData(accessToken) {
    let payload = "";
    let tokenData = {};

    try {
      payload = accessToken.split(".")[1];
      tokenData = JSON.parse(atob(payload));
    } catch (error) {
      throw console.log(error);
    }

    return tokenData;
  }
};
